import { SelectItem } from "primeng/api";

enum IM1DataSet {
    Documents = 1,
    Allergies = 2,
    Immunisations = 3,
    Prescriptions = 4,
    Problems = 5,
    Episodes = 6,
    Investigations = 7
}

const IM1DataSetsMap: Record<IM1DataSet, string> = {
    1: "Documents",
    2: "Allergies",
    3: "Immunisations",
    4: "Prescriptions",
    5: "Problems",
    6: "Episodes",
    7: "Investigations",
};

function createOptions() {
    return Object.keys(IM1DataSetsMap)
        .map(k => +k as IM1DataSet)
        .map(k => <SelectItem>{ value: k, label: IM1DataSetsMap[k] });
}

export { IM1DataSet, IM1DataSetsMap, createOptions };
